export const getHeadersEmptyResponse = () => ({
  title: 'Conversation not found',
  metas: []
});

export const buildHeadersData = () => ({
  links: []
});

export default { buildHeadersData, getHeadersEmptyResponse };
